const QUERYOPERATOR = {
  AND: "AND",
  OR: "OR",
  EXCEPT: "EXCEPT",
};

export default QUERYOPERATOR;
